import { render, staticRenderFns } from "./NewBlock.vue?vue&type=template&id=0b17f442&scoped=true&"
import script from "./NewBlock.vue?vue&type=script&lang=js&"
export * from "./NewBlock.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./NewBlock.vue?vue&type=style&index=0&id=0b17f442&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./NewBlock.vue?vue&type=style&index=1&lang=css&")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0b17f442",
  null
  ,true
)

export default component.exports